import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MuiSelect from '@material-ui/core/Select';
import { MenuItem } from '@material-ui/core';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import useStyles from './Select.styles';
import { Loader } from '../loaders';

const Select = ({ className, selectedValueClassName, value, label, options, onChange, muiClasses, loading, disabled }) => {
  const classes = useStyles();

  const handleChange = useCallback(
    (event) => {
      event.stopPropagation();
      if (onChange) onChange(event.target.value);
    },
    [onChange]
  );

  if (loading) return <Loader className={classes.loader} size={30} />;

  return (
    <div className={className}>
      <FormControl>
        {!!label && <InputLabel id="select-label">{label}</InputLabel>}

        <MuiSelect
          id="select"
          name="select"
          classes={muiClasses}
          labelId="select-label"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          renderValue={(selectedValue) => {
            const selectedOption = options.find(({ value: v }) => v === selectedValue);
            return selectedOption && selectedOption.renderValue ? (
              selectedOption.renderValue()
            ) : (
              <span className={selectedValueClassName}>{selectedOption && selectedOption.label}</span>
            );
          }}>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.renderLabel ? option.renderLabel() : option.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
    </div>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
  selectedValueClassName: PropTypes.string,
  muiClasses: PropTypes.shape(),
  value: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  value: '',
  label: '',
  onChange: undefined,
  className: undefined,
  selectedValueClassName: undefined,
  muiClasses: undefined,
  loading: false,
  disabled: false,
};

export default React.memo(Select);
